import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import moneyFormatter from 'helpers/money-formatter';
import './InvoicesPaymentConfirmationTemplate.css';

const InvoicesPaymentConfirmationTemplateFooter = ({
  Currency,
  TotalInvoiceAmountFooter,
  TotalBalanceDueAmountFooter,
}) => (
  <tr>
    <td colSpan={3}><div /></td>
    <td><div className="invoices-payment-confirmation-table__footer__amount invoices-payment-confirmation-table__footer__amount--align-right"><span>{i18n.t('invoicesPaymentSummary:Invoice Total')} ({Currency})</span><span>{moneyFormatter(TotalInvoiceAmountFooter)}</span></div></td>
    <td><div className="invoices-payment-confirmation-table__footer__amount invoices-payment-confirmation-table__footer__amount--align-right"><span>{i18n.t('invoicesPaymentSummary:Payment Amount')} ({Currency})</span><span className="invoices-payment-confirmation-table__footer__payment-amount">{moneyFormatter(TotalBalanceDueAmountFooter)}</span></div></td>
  </tr>
);

InvoicesPaymentConfirmationTemplateFooter.propTypes = {
  TotalInvoiceAmountFooter: PropTypes.number,
  Currency: PropTypes.string,
  TotalBalanceDueAmountFooter: PropTypes.number,
};

export default InvoicesPaymentConfirmationTemplateFooter;



// WEBPACK FOOTER //
// ./src/components/InvoicesPaymentConfirmationTemplate/InvoicesPaymentConfirmationTemplateFooter.jsx